import AppHeader from '../AppHeader'
let utils = require('../../utils')
export default {
  name: 'shop-order-list',
  async created () {
    // 期間チェック
    const res = await this.$store.dispatch('STOCK_CHECK_PERIOD')
    if (!res.data) {
      this.$router.push('/stock')
    }
    this.getShopOrders()
  },
  data () {
    return {
      statuses: {
        '店舗残取り前': 'before_stock_check',
        '本部否認済み': 'head_office_reject',
        '店舗管理者承認待ち': 'before_manager_confirm',
        '本部承認待ち': 'before_head_office_confirm',
        '本部承認済み': 'head_office_confirmed',
        '発注済み': 'order_completed'
      },
      shopOrders: [],
      shopOrderCommonInfo: '',
      queryStatus: '',
      getShopsEndFlag: false,
      getShopOrdersEndFlag: false
    }
  },
  computed: {},
  components: {
    AppHeader
  },
  methods: {
    async getShopOrders () {
      this.getShopOrdersEndFlag = false
      let data = {
        status: this.queryStatus
      }
      this.shopOrders = []
      let res = await this.$store.dispatch('SHOP_ORDERS_ALL_GET', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      if (res.data.shop_orders.length > 0) {
        await res.data.shop_orders.map(shopOrder => {
          let converedShopOrder = {}
          converedShopOrder = utils.kebabSnakeConversion(shopOrder)
          converedShopOrder.id = shopOrder.id
          this.shopOrders.push(converedShopOrder)
        })
      } else {
        this.shopOrders = []
      }
      this.shopOrderCommonInfo = res.data.shop_order_common_info
      this.getShopOrdersEndFlag = true
    },
    async goShopOrderDetail (shopOrderId) {
      this.$router.push(`/shop_order/${shopOrderId}/detail`)
    },
    async confirmAllOrder (status) {
      const data = {
        deadline_date: this.shopOrderCommonInfo['deadline_date'],
        status: status
      }
      await this.$store.dispatch('SHOP_ORDER_UPDATE_ALL', data)
                        .catch(err => {
                          console.log(err)
                          return
                        })
      this.getShopOrders()
    },
    isOutputDisabled () {
      for (let i = 0; i < this.shopOrders.length; i++) {
        if (this.shopOrders[i].status !== 'head_office_confirmed' && this.shopOrders[i].status !== 'order_completed') {
          return true
        }
      }
      return false
    },
    isOrderCompletedDisabled () {
      for (let i = 0; i < this.shopOrders.length; i++) {
        if (this.shopOrders[i].status !== 'head_office_confirmed') {
          return true
        }
      }
      return false
    },
    isOrderCompleted () {
      if (this.shopOrders[0].status == 'order_completed') {
        return true
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-order-list.js